setup(function(options) {
  options.test = 'restart-b2g';
  options.phase = 'restart-b2g';
});
